<template>
<div class="ti">
<!--  <Alert type="warning" id='alert_tips' show-icon>请谨慎操作，删除无法恢复！</Alert> -->
  <div>
    <el-button size="mini" type="primary text2"  @click="modals" v-if="userJid[0]['id']==5001001">添加税盘</el-button>
<!--    <el-select v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="userJid[0]['id']==5001001">
      <el-option
        key=""
        label="全部1"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select> -->
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">公司名称</th>
            <th class="text-left">公司税号</th>
            <th class="text-left">公司地址与电话</th>
            <th class="text-left">公司开户行与账号</th>
            <th class="text-left">公司邮箱</th>
            <th class="text-left">商品编码</th>
            <th class="text-left">开票人</th>
            <th class="text-left">收款人</th>
            <th class="text-left">复核人</th>
            <th class="text-left">剩余发票数量</th>
            <th class="text-left">税盘备注</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.XSF_MC}}</td>
            <td >{{item.XSF_NSRSBH}}</td>
            <td >{{item.XSF_DZDH}}</td>
            <td >{{item.XSF_YHZH}}</td>
            <td >{{item.XSF_LXFS}}</td>
            <td >{{item.SPBM}}</td>
            <td >{{item.KPR}}</td>
            <td >{{item.SKR}}</td>
            <td >{{item.FHR}}</td>
            <td >{{item.invoice_count}}</td>
            <td >{{item.remark}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="modals_getprojects(item.id)" v-if="userJid[1]['id']==5001002">添加项目</div>
              <div style="color: #1867c0;cursor: pointer;" @click="modals(item)" v-if="userJid[2]['id']==5001003">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="delete_by_id(item.id)" v-if="userJid[3]['id']==5001004">删除</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
          <Page :total="total" :page-size="psize" @on-change="searchs"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :loading='loading'
        :ok-text="anxiu"
        width="800"
        :title="title"
        @on-ok="save">
        <div >
          <el-form  label-width="180px;"  style="height: 600px;overflow: auto;">
            <el-form-item label="id" :rules="[{required: true}]" style="display: none;">
              <el-input   v-model="dades.id"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" :rules="[{required: true}]">
              <el-input   v-model="dades.XSF_MC"></el-input>
            </el-form-item>
            <el-form-item label="公司税号" :rules="[{required: true}]">
              <el-input v-model="dades.XSF_NSRSBH"></el-input>
            </el-form-item>
            <el-form-item label="公司地址与电话" :rules="[{required: true}]">
              <el-input v-model="dades.XSF_DZDH"></el-input>
            </el-form-item>
            <el-form-item label="公司开户行及账号" :rules="[{required: true}]">
              <el-input v-model="dades.XSF_YHZH"></el-input>
            </el-form-item>
            <el-form-item label="公司邮箱" :rules="[{required: true}]">
              <el-input v-model="dades.XSF_LXFS"></el-input>
            </el-form-item>
            <el-form-item label="商品编码" :rules="[{required: true}]">
              <el-input v-model="dades.SPBM"></el-input>
            </el-form-item>
            <el-form-item label="开票人" :rules="[{required: true}]">
              <el-input v-model="dades.KPR"></el-input>
            </el-form-item>
            <el-form-item label="收款人" :rules="[{required: true}]">
              <el-input v-model="dades.SKR"></el-input>
            </el-form-item>
            <el-form-item label="复核人" :rules="[{required: true}]">
              <el-input v-model="dades.FHR"></el-input>
            </el-form-item>
            <el-form-item label="税盘备注" :rules="[{required: true}]">
              <el-input v-model="dades.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
    </Modal>




    <Modal
        v-model="modal_addprojects"
        ok-text="保存"
        width="400"
        title="添加项目"
        @on-ok="ok_addprojects">
        <div >
         <el-form  label-width="180px;"  style="max-height:400px;overflow:auto;">
            <CheckboxGroup   v-model="arr_checkedpids" @on-change="fun1">

                <Checkbox  :label="item.pid"  v-for="item in data_projects" :key="item.pid" >{{item.pname}}</Checkbox>

            </CheckboxGroup>
          </el-form>
        </div>
    </Modal>


</div>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      loading:true,
      url:'',
      url1:'',
      img:[],

      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      dades: {id:'',XSF_MC:'',XSF_NSRSBH:'',XSF_DZDH:'',XSF_YHZH: '',XSF_LXFS:'',SPBM:'',KPR:'',SKR: '',FHR:'',invoice_count:'',remark:'',},
      // dades_label:{XSF_MC:'公司名称',XSF_NSRSBH:'公司税号',XSF_DZDH:'公司地址与电话',XSF_YHZH:'公司开户行及账号',
      //   XSF_LXFS:'公司邮箱',SPBM:'商品编码',KPR:'开票人',SKR:'收款人',FHR:'复核人',remark:'税盘备注'};1

      opdade:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      psize:'12',
      search:'',
      userJid:[],
      modal1: false,
      modal_addprojects:false,
      title:'添加',
      anxiu:'保存',
      loading:true,
      data_projects:[],
      //checkAllGroup: [],
      arr_checkedpids:[],
      ftid:1,
    }
  },
  //界面没出来前加载
  created() {
    this.userJid = [{id:''},{id:''},{id:''},{id:''}];
    this.$myhttp.get('admin/lavel3?pid=5001',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // console.log(backdata.data);
        if(backdata.data != 1){
          var date = backdata.data;
          date.forEach(item => {
            //本界面权限
            if(item.id == 5001001){
              this.userJid[0]['id'] = item.id;
            }
            if(item.id == 5001002){
              this.userJid[1]['id'] = item.id;
            }
            if(item.id == 5001003){
              this.userJid[2]['id'] = item.id;
            }
            if(item.id == 5001004){
              this.userJid[3]['id'] = item.id;
            }
          });
        }else{
          //本界面权限
          this.userJid = [{id:'5001001'},{id:'5001002'},{id:'5001003'},{id:'5001004'}];
        }
        // console.log(this.userJid)
      });
  },
  // 加载数据
  mounted(){
      this.searchs();
    },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    searchs(page){
      page=typeof(page)==='number'?page:1;
      this.$Loading.start();
      this.$myhttp.get('admin/taxplate?search='+this.search+'&psize='+this.psize+'&page='+page,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          //console.log(backdata.data)
          let data = backdata.data;
            this.desserts = data.data;
            this.total = data.total;
            this.psize = data.psize;
            this.$Loading.finish();

        });
    },
    ok_addprojects(){//税盘添加项目
          if(!this.arr_checkedpids.length){this.$Message.error("请选择项目");return false;}
          var pids_instr=this.arr_checkedpids.join(',');
          this.$Loading.start();
          this.$myhttp.post('admin/taxplateProjects',{'pids_instr':pids_instr,'ftid':this.ftid},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
                if(backdata.data[0] == 1){
                  this.$Message.success(backdata.data[1]);
                }else{
                  this.$Message.error(backdata.data[1]);
                }
                this.$Loading.finish();
            });
    },
    fun1(arr){this.arr_checkedpids=arr;},//税盘选中项目的pid集合
    //弹窗：添加项目
    modals_getprojects(id){
      //加载公司权限列表
      this.$Loading.start();
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[1] == 2){
              this.data =  backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id=backdata.data[3];
          if(this.dades.company_id){
            this.$myhttp.post('admin/taxplateProjects',{'id':id},{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
              this.data_projects=backdata.data.data;
              this.ftid=backdata.data.ftid;
              this.arr_checkedpids=backdata.data.arr_checkedpids;
              this.$Loading.finish();
              this.$forceUpdate();
            });
          }
          this.$Loading.finish();
      });
      this.modal_addprojects = true;
    },
    // onchange_pids(arr){
    //     arr_checkedpids
    // },
    //保存
    save(){
      var content_ok=1;
      // var arr_label={XSF_MC:'公司名称',XSF_NSRSBH:'公司税号',XSF_DZDH:'公司地址与电话',XSF_YHZH:'公司开户行及账号',
      //  XSF_LXFS:'公司邮箱',SPBM:'商品编码',KPR:'开票人',SKR:'收款人',FHR:'复核人',remark:'税盘备注'};
      if(!this.dades.XSF_MC){
         this.$Message.error('公司名称不能为空');
         content_ok=0;
      }else if(!this.dades.XSF_NSRSBH){
        this.$Message.error('公司税号不能为空!');
        content_ok=0;
      }else if(!this.dades.XSF_DZDH){
        this.$Message.error('公司地址与电话不能为空!');
        content_ok=0;
      }else if(!this.dades.XSF_YHZH){
        this.$Message.error('公司开户行及账号不能为空!');
        content_ok=0;
      }else if(!this.dades.XSF_LXFS){
        this.$Message.error('公司邮箱不能为空!');
        content_ok=0;
      }else if(!this.dades.SPBM){
        this.$Message.error('商品编码不能为空!');
        content_ok=0;
      }else if(!this.dades.KPR){
        this.$Message.error('开票人不能为空!');
        content_ok=0;
      }else if(!this.dades.SKR){
        this.$Message.error('收款人不能为空!');
        content_ok=0;
      }else if(!this.dades.FHR){
        this.$Message.error('复核人不能为空!');
        content_ok=0;
      }else if(!this.dades.remark){
        this.$Message.error('税盘备注不能为空!');
        content_ok=0;
      }

      if(content_ok){
          this.$Loading.start();
          this.$myhttp.post('admin/taxplateSave',this.dades,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data[0] == 1){
                this.modal1=false;
                this.searchs();
                this.$Message.success(backdata.data[1]);
                this.dades={id:'',XSF_MC:'',XSF_NSRSBH:'',XSF_DZDH: '',XSF_YHZH:'',XSF_LXFS:'',SPBM:'',KPR: '',SKR:'',FHR:'',remark:'',};
              }else{
                this.$Message.error(backdata.data[1]);
                this.loadings();//不关闭窗口
              }
              this.$Loading.finish();
          });
      }else{this.loadings();}//不关闭窗口


    },
    //添加或修改
    modals(item){
      this.anxiu = "保存";
      if(item.id){
        this.title = "编辑";
        this.dades={
          id:item.id,
          XSF_MC:item.XSF_MC,
          XSF_NSRSBH:item.XSF_NSRSBH,
          XSF_DZDH:item.XSF_DZDH,
          XSF_YHZH:item.XSF_YHZH,
          XSF_LXFS:item.XSF_LXFS,
          SPBM:item.SPBM,
          KPR:item.KPR,
          SKR:item.SKR,
          FHR:item.FHR,
          remark:item.remark,
        }
      }
      //加载公司权限列表
       this.$Loading.start();
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[1] == 2){
              this.data =  backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id=backdata.data[3];
          if(this.dades.company_id){
             this.$myhttp.get('admin/getuserOwner?id='+this.dades.company_id,{
            'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
              this.opdade=backdata.data;
              this.$Loading.finish();
              this.$forceUpdate();
            });
          }
          this.$Loading.finish();
      });
      this.modal1 = true;
    },

    delete_by_id(id){
        id=typeof(id)==='number'?id:0;
        if(!id){
          this.$Message.error('参数出错,请规范操作!');
          return false;
        }
        this.$Modal.confirm({
            title: '警告',
            content: '<p>删除该税盘就无法恢复，是否继续删除？</p>',
            onOk: () => {
                this.$Loading.start();
                this.$myhttp.post('admin/taxplateDelete',{'id':id},{
                  'Content-Type': 'application/x-www-form-urlencoded'
                  }).then(backdata=>{ // 异步执行成功后
                  //console.log(backdata);
                    if(backdata.data[0] == 1){
                      this.searchs();
                      this.$Message.success(backdata.data[1]);
                    }else{
                      this.$Message.error(backdata.data[1]);
                    }
                    this.$Loading.finish();
                });
            },
            onCancel: () => {
                this.$Message.info('取消删除');
            }
        });

    },
    loadings(){
      this.loading = false;
      setTimeout(() => {
        this.loading = true;
      }, 500);
    }

  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(247, 243, 243);
  font-size: 20px;
  margin-top: 3%;
}
</style>
<style>
.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/taxplate.vue